import './CategoryTable.css';
import {useTranslation} from 'react-i18next';

import {cleanerProducts} from './staticCategories';


export const StaticCategoryTable = (props: { description: string }) => {
    const {t, i18n} = useTranslation();
    const language = i18n.language as keyof typeof cleanerProducts; // Type assertion here
    const products = cleanerProducts[language]; // Get products based on current language

    return (
        <div>
            <div id='sheetTableId' className='wb-padding-s sheetTableDesktop'>
                <table className='wb-table wb-table--striped sheetTable'>
                    <thead className='tableHeader'>
                    <tr>
                        {/* <th scope="col">#</th> */}
                        <th scope="col">{t('ProductName')}</th>
                        <th scope="col">{t('Description')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {products.map((product: { name: any; description: any; }, index: number) => (
                        <tr key={index}>
                            {/* <th scope="row">{index + 1}</th> */}
                            <td>
                                <a
                                    target='_blank'
                                    className='wb-link dt-link'
                                    href="https://gms.aftersales.daimlertruck.com/Default.aspx?UserID=Guest&MBReleaseNo=none"
                                    rel="noreferrer"
                                >
                                    {product.name}
                                </a>
                            </td>
                            <td>{product.description}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
